<script setup>
import BackgroundSection from "./BackgroundSection.vue";
import content from "../content.js";

const portfolio = content.portfolio;
</script>

<template>
    <BackgroundSection
        section-id="portfolio"
        :video="portfolio.video"
        :image="portfolio.image"
        overlay-class="bg-black/50"
    >
        <div class="max-w-6xl mx-auto px-6 py-10 text-center">
            <h2
                class="text-2xl sm:text-4xl md:text-5xl font-bold mb-8 sm:mb-12 mt-8 md:mt-10 text-white drop-shadow-lg"
                data-aos="fade-up"
            >
                {{ portfolio.title }}
            </h2>

            <div class="grid sm:grid-cols-2 md:grid-cols-3 gap-10 mb-8 md:mb-0">
                <div
                    v-for="(item, i) in portfolio.items"
                    :key="i"
                    class="relative group rounded-2xl overflow-hidden shadow-2xl transform transition duration-500 hover:-translate-y-2 hover:shadow-3xl"
                    data-aos="fade-up"
                    :data-aos-delay="i * 100"
                >
                    <!-- Image with gradient overlay -->
                    <div class="relative h-60 sm:h-64 md:h-72">
                        <img
                            :src="item.image"
                            :alt="item.title"
                            class="absolute inset-0 w-full h-full object-fill transition-transform duration-500 group-hover:scale-105"
                        />
                        <div
                            class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"
                        ></div>
                    </div>

                    <!-- Content overlay -->
                    <div
                        class="absolute bottom-0 left-0 right-0 p-5 text-left text-white"
                    >
                        <h3
                            class="text-xl sm:text-2xl font-semibold mb-1 text-shadow"
                        >
                            {{ item.title }}
                        </h3>
                        <p
                            class="text-white text-sm sm:text-base line-clamp-2 text-shadow"
                        >
                            {{ item.description }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </BackgroundSection>
</template>
